"use client";

import { useTranslations } from 'next-intl';
import { CreatorAdvisor } from '@/components/ai/creator-advisor';
import { Scale, TrendingUp, Megaphone, Music2, BookOpen, Globe, Sparkles } from 'lucide-react';

/** The Maker AI Tutor & Advisor (Gordon 2026-11-02: renamed from "Creator AI
 *  Advisor" — "built on our collective knowledge and experiences"). */
export default function CreatorAIPage() {
  const t = useTranslations('makerAi');
  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <div className="border-b border-border/60 bg-background/80 backdrop-blur-sm sticky top-[var(--header-height)] z-20">
        <div className="px-3 sm:px-4 py-4">
          <div className="flex items-center gap-3">
            <div className="h-9 w-9 rounded-full bg-primary flex items-center justify-center">
              <Sparkles className="h-5 w-5 text-primary-foreground" />
            </div>
            <div>
              <h1 className="text-lg font-bold">{t('title')}</h1>
              <p className="text-sm text-muted-foreground">{t('subtitle')}</p>
            </div>
          </div>

          {/* Domain capability pills */}
          <div className="flex flex-wrap gap-2 mt-3">
            {[
              { icon: Scale,      label: t('pillLegal'), bg: 'bg-blue-600' },
              { icon: TrendingUp, label: t('pillFinance'), bg: 'bg-green-600' },
              { icon: Megaphone,  label: t('pillMarketing'), bg: 'bg-purple-600' },
              { icon: Music2,     label: t('pillBusiness'), bg: 'bg-orange-600' },
              { icon: BookOpen,   label: t('pillPublishing'), bg: 'bg-pink-600' },
              { icon: Globe,      label: t('pillSync'), bg: 'bg-teal-600' },
            ].map(({ icon: Icon, label, bg }) => (
              <span key={label} className={`inline-flex items-center gap-1 ${bg} text-white px-2 py-0.5 rounded-full text-xs font-medium`}>
                <Icon className="h-3 w-3" />{label}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* Main advisor — full height */}
      <div className="flex-1 max-w-2xl w-full px-0 py-4 flex flex-col" style={{ minHeight: 'calc(100vh - 160px)' }}>
        <div className="flex-1 bg-card rounded-xl border border-border/60 overflow-hidden flex flex-col shadow-sm">
          <CreatorAdvisor variant="full" className="flex-1" />
        </div>
        <p className="text-center text-xs text-muted-foreground mt-3 px-4">
          {t('disclaimer')}
        </p>
      </div>
    </div>
  );
}
